import Spinner from "@anwb/poncho/components/spinner";

function LoadingSpinner() {
  return <Spinner size="medium" message="Loading..." />;
}

export default LoadingSpinner;
